import axios from "axios";
import { FLEET } from "./site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AIRPORTS = [
  { code: "LHR", name: "London Heathrow (LHR)" },
  { code: "LGW", name: "London Gatwick (LGW)" },
  { code: "STN", name: "London Stansted (STN)" },
  { code: "LTN", name: "London Luton (LTN)" },
  { code: "LCY", name: "London City (LCY)" },
  { code: "FAB", name: "Farnborough (FAB)" },
  { code: "NHT", name: "RAF Northolt (NHT)" },
  { code: "BQH", name: "Biggin Hill (BQH)" },
];

const byId = (id) => FLEET.find((f) => f.id === id) || {};
export const CLASS_IMAGES = {
  business: byId("business").image,
  executive: byId("first").image,
  mpv: byId("space").image,
  suv: byId("suv").image,
};

export const HOUR_OPTIONS = [4, 5, 6, 7, 8, 10, 12];

export const fetchAutocomplete = async (q) => {
  const { data } = await axios.get(`${API}/places/autocomplete`, { params: { q } });
  return data.suggestions || [];
};

export const fetchQuote = async (payload) => {
  const { data } = await axios.post(`${API}/quote`, payload);
  return data;
};

const TOKEN_KEY = "ucc_admin_token";
export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);
export const setAdminToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(TOKEN_KEY);
const authHeaders = () => {
  const t = getAdminToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const adminLogin = async (username, password) => {
  const { data } = await axios.post(`${API}/admin/login`, { username, password });
  setAdminToken(data.token);
  return data;
};

export const createBooking = async (payload) => {
  const { data } = await axios.post(`${API}/bookings`, payload);
  return data;
};

export const fetchBookings = async () => {
  const { data } = await axios.get(`${API}/bookings`, { headers: authHeaders() });
  return data;
};

export const updateBooking = async (ref, patch) => {
  const { data } = await axios.patch(`${API}/bookings/${ref}`, patch, { headers: authHeaders() });
  return data;
};

export const formatGBP = (n) => {
  if (n === null || n === undefined) return "";
  return Number.isInteger(n) ? `£${n}` : `£${n.toFixed(2)}`;
};

export const ASAP_MESSAGE = "Please call or message on WhatsApp for ASAP bookings. Thank you!";

// True if the selected London date/time is less than 24h from now (London time).
export const isWithin24hLondon = (dateStr, timeStr) => {
  if (!dateStr || !timeStr) return false;
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/London", hourCycle: "h23",
    year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit",
  }).formatToParts(new Date());
  const g = (t) => parts.find((p) => p.type === t)?.value;
  const nowLondon = new Date(`${g("year")}-${g("month")}-${g("day")}T${g("hour")}:${g("minute")}`);
  const selected = new Date(`${dateStr}T${timeStr}`);
  return selected.getTime() - nowLondon.getTime() < 24 * 3600 * 1000;
};
